export const specialEndorsementWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const specialEndorsementValueStyles = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};
